module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/blackstar-ka.66742b3.png";